/* eslint-disable no-console */

import { register } from 'register-service-worker'
import pwaService from './services/pwaService'

// Initialize PWA service
pwaService.init();

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready(/* registration */) {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      );
    },
    registered(registration) {
      console.log('Service worker has been registered.');
      
      // Check for updates periodically
      setInterval(() => {
        registration.update();
      }, 1000 * 60 * 60); // Check every hour
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading.');
    },
    updated(registration) {
      console.log('New content is available; please refresh.');
      pwaService.notifyUpdateAvailable(registration);
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
      pwaService.notifyOffline();
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    }
  });
}